import { create } from 'zustand';
import { DateRange } from 'react-day-picker';
import { ColumnState } from 'ag-grid-community';
import { getCurrentMonthDateRange } from 'src/utils/date/dateUtils';
import { defaultTQC2060_R01HdrDto, defaultTQC2060_R01DtlDto, TQC2060_R01HeaderDto, TQC2060_R01DetailDto } from './Dto_TQC2060_R01';

export interface TQC2060_R01Filter {
    compCd: string;           // 사업장
    testDt: DateRange | undefined; // 시험기간(범위)
    empNo: string;            // 시험자
    empNm: string;            // 시험자명
    carModel: string;         // 차종
    equipmentCd: string;      // 시험기기
}

export interface Store_TQC2060_R01 {
	TQC2060_R01Filter: TQC2060_R01Filter;
	TQC2060_R01PastFilter: TQC2060_R01Filter;
	setTQC2060_R01Filter: (filter: Partial<TQC2060_R01Filter>) => void;
	setTQC2060_R01PastFilter: (filter: Partial<TQC2060_R01Filter>) => void;

	TQC2060_R01List: TQC2060_R01HeaderDto[];
	setTQC2060_R01List: (TQC2060_R01List: TQC2060_R01HeaderDto[]) => void;

	selectedTQC2060_R01: TQC2060_R01HeaderDto | undefined;
	setSelectedTQC2060_R01: (item: TQC2060_R01HeaderDto | undefined) => void;
	initSelectedTQC2060_R01: () => void;

	editTQC2060_R01: TQC2060_R01HeaderDto | null;
	setEditTQC2060_R01: (item: TQC2060_R01HeaderDto | null) => void;

	// ====== 디테일 관리 ======
	TQC2060_R01DetailList: TQC2060_R01DetailDto[];
	setTQC2060_R01DetailList: (data: TQC2060_R01DetailDto[]) => void;
	insertTQC2060_R01DetailList: (data: TQC2060_R01DetailDto[], index?: number) => void;
	removeTQC2060_R01DetailList: (valueIndex: number) => void;
	updateTQC2060_R01DetailList: (valueIndex: number, data: TQC2060_R01DetailDto) => void;

	selectedTQC2060_R01DetailList: string[];
	setSelectedTQC2060_R01DetailList: (idList: string[]) => void;
	addSelectedTQC2060_R01DetailList: (idList: string[]) => void;
	removeSelectedTQC2060_R01DetailList: (idList?: string[]) => void;
	initSelectedTQC2060_R01DetailList: () => void;

	deletedTQC2060_R01DetailList: string[];
	setDeletedTQC2060_R01DetailList: (idList: string[]) => void;
	addDeletedTQC2060_R01DetailList: (idList: string[]) => void;
	removeDeletedTQC2060_R01DetailList: (idList?: string[]) => void;

	originalTQC2060_R01DetailList: TQC2060_R01DetailDto[];
	setOriginalTQC2060_R01DetailList: (data: TQC2060_R01DetailDto[]) => void;

	columnState: ColumnState[] | null;
	setColumnState: (state: ColumnState[] | null) => void;
	detailColumnState: ColumnState[] | null;
	setDetailColumnState: (state: ColumnState[] | null) => void;

	allCount: number;					setAllCount: (allCount: number) => void;
	detailFetchTrigger: boolean;		setDetailFetchTrigger: (trigger: boolean) => void;
	
	// ====== DetailTable 상태 관리 ======
	prevSampleCount: number | undefined;
	setPrevSampleCount: (count: number | undefined) => void;
	isEditing: boolean;
	setIsEditing: (editing: boolean) => void;
	prevTestDetails: TQC2060_R01DetailDto[] | undefined;
	setPrevTestDetails: (details: TQC2060_R01DetailDto[] | undefined) => void;

	scrollTop: number | null;
	setScrollTop: (top: number | null) => void;
	detailScrollTop: number | null;
	setDetailScrollTop: (top: number | null) => void;

	initData: () => void;
}

export const defaultTQC2060_R01Filter : TQC2060_R01Filter = {
    compCd: '',
    testDt: getCurrentMonthDateRange(),
    empNo: '',
    empNm: '',
    carModel: '',
    equipmentCd: ''
};

export const useTQC2060_R01Store = create<Store_TQC2060_R01>((set) => ({
	TQC2060_R01Filter: defaultTQC2060_R01Filter,
	TQC2060_R01PastFilter: defaultTQC2060_R01Filter,
	setTQC2060_R01Filter: (filter: Partial<TQC2060_R01Filter>) => set((state) =>  ({
		...state,
		TQC2060_R01Filter: {
			...state.TQC2060_R01Filter,
			...filter
		}	
	})),
	setTQC2060_R01PastFilter: (filter: Partial<TQC2060_R01Filter>) => set((state) =>  ({
		...state,
		TQC2060_R01PastFilter: {
			...state.TQC2060_R01PastFilter,
			...filter
		}	
	})),

	TQC2060_R01List: [],
	setTQC2060_R01List: (TQC2060_R01List: TQC2060_R01HeaderDto[]) => set({ TQC2060_R01List }),

	selectedTQC2060_R01: undefined,
	setSelectedTQC2060_R01: (item: TQC2060_R01HeaderDto | undefined) => set(() => {

		return { 
			selectedTQC2060_R01: item,
			selectedTQC2060_R01DetailList: [], deletedTQC2060_R01DetailList: [],
			detailFetchTrigger: true,
			detailScrollTop: null,
		};
	}),
	initSelectedTQC2060_R01: () => set({ selectedTQC2060_R01: undefined, editTQC2060_R01: defaultTQC2060_R01HdrDto, detailFetchTrigger: false }),
	
	editTQC2060_R01: defaultTQC2060_R01HdrDto,
	setEditTQC2060_R01: (item: TQC2060_R01HeaderDto | null) => set(() => {
		let editData = defaultTQC2060_R01HdrDto;
		if (item) {
			editData = { ...item };
		}
		return { editTQC2060_R01: editData };
	}),

	// ====== 디테일 관리 ======
	TQC2060_R01DetailList: [],
	setTQC2060_R01DetailList: (data: TQC2060_R01DetailDto[]) => set((state) => {
		let newList: TQC2060_R01DetailDto[] = [];
		let valueAndOrderIndex = 1;
		data.forEach(item => {
			newList.push({
				...item,
				valueIndex: item.valueIndex > 0 ? item.valueIndex : valueAndOrderIndex,
				orderIndex: item.orderIndex > -1 ? item.orderIndex : valueAndOrderIndex,
				orderIndexSeq: Math.max(item.orderIndexSeq, 0)
			});
			valueAndOrderIndex++;
		});
		return { ...state, TQC2060_R01DetailList: newList };
	}),
	insertTQC2060_R01DetailList: (data: TQC2060_R01DetailDto[], index?: number) => set((state) => {
		const newList = [...state.TQC2060_R01DetailList];
		let valueIndex = Math.max(0, ...newList.map(i => i.valueIndex || 0)) + 1;
		let targetOrderIndex = index || 1;
		const maxSeq = Math.max(0, ...newList.filter(i => i.orderIndex === targetOrderIndex).map(i => i.orderIndexSeq || 0));
		let targetSeq = maxSeq + 1;
		const toInsert = data.map(item => ({ ...defaultTQC2060_R01DtlDto, ...item, valueIndex: valueIndex++, orderIndex: targetOrderIndex, orderIndexSeq: targetSeq }));
		if (index === undefined) {
            newList.push(...toInsert);
        } else {
            newList.splice(index, 0, ...toInsert);
        }
		return { TQC2060_R01DetailList: newList };
	}),
	removeTQC2060_R01DetailList: (valueIndex: number) => set((state) => ({
		TQC2060_R01DetailList: [...state.TQC2060_R01DetailList].filter(item => item.valueIndex !== valueIndex)
	})),
	updateTQC2060_R01DetailList: (valueIndex: number, data: TQC2060_R01DetailDto) => set((state) => ({
		TQC2060_R01DetailList: state.TQC2060_R01DetailList.map(item => item.valueIndex === valueIndex ? data : item)
	})),

	selectedTQC2060_R01DetailList: [],
	setSelectedTQC2060_R01DetailList: (idList: string[]) => set((state) => ({
		...state,
		selectedTQC2060_R01DetailList: idList,
	})),
	addSelectedTQC2060_R01DetailList: (idList: string[]) => set((state) => ({
		selectedTQC2060_R01DetailList: [...state.selectedTQC2060_R01DetailList, ...idList]
	})),
	removeSelectedTQC2060_R01DetailList: (idList?: string[]) => set((state) => ({
		selectedTQC2060_R01DetailList: [...state.selectedTQC2060_R01DetailList].filter(v => idList ? !idList.includes(v) : false)
	})),
	initSelectedTQC2060_R01DetailList: () => set({ selectedTQC2060_R01DetailList: [] }),

	deletedTQC2060_R01DetailList: [],
	setDeletedTQC2060_R01DetailList: (idList: string[]) => set({ deletedTQC2060_R01DetailList: idList }),
	addDeletedTQC2060_R01DetailList: (idList: string[]) => set((state) => {
		const _deleted = [...state.deletedTQC2060_R01DetailList];
		for (const v of idList) {
			const isInserted = state.TQC2060_R01DetailList.find(it => it.valueIndex === Number(v) && it.inserted);
			const isModified = state.TQC2060_R01DetailList.find(it => it.valueIndex === Number(v) && it.isModified);
			if (!isInserted && !isModified) _deleted.push(v);
		}
		return { deletedTQC2060_R01DetailList: _deleted };
	}),
	removeDeletedTQC2060_R01DetailList: (idList?: string[]) => set((state) => ({
		deletedTQC2060_R01DetailList: [...state.deletedTQC2060_R01DetailList].filter(v => idList ? !idList.includes(v) : false)
	})),

	originalTQC2060_R01DetailList: [],
	setOriginalTQC2060_R01DetailList: (data: TQC2060_R01DetailDto[]) => set((state) => {
		let newList: TQC2060_R01DetailDto[] = [];
		let idx = 1;
		data.forEach(item => {
			newList.push({ ...defaultTQC2060_R01DtlDto, ...item, valueIndex: idx, orderIndex: idx, orderIndexSeq: idx });
			idx++;
		});
		return { ...state, originalTQC2060_R01DetailList: newList };
	}),

	columnState: null,
	setColumnState: (state: ColumnState[] | null) => set({ columnState: state }),
	detailColumnState: null,
	setDetailColumnState: (state: ColumnState[] | null) => set({ detailColumnState: state }),

	allCount: 0,					setAllCount: (allCount: number) => set({ allCount }),
	detailFetchTrigger: false,		setDetailFetchTrigger: (trigger: boolean) => set({ detailFetchTrigger: trigger }),
	
	// ====== DetailTable 상태 관리 ======
	prevSampleCount: undefined,
	setPrevSampleCount: (count: number | undefined) => set({ prevSampleCount: count }),
	isEditing: false,
	setIsEditing: (editing: boolean) => set({ isEditing: editing }),
	prevTestDetails: undefined,
	setPrevTestDetails: (details: TQC2060_R01DetailDto[] | undefined) => set({ prevTestDetails: details }),

	scrollTop: null,
	setScrollTop: (top: number | null) => set({ scrollTop: top }),
	detailScrollTop: null,
	setDetailScrollTop: (top: number | null) => set({ detailScrollTop: top }),

	initData: () => set((state) => ({
		...state,
		TQC2060_R01Filter: defaultTQC2060_R01Filter,
		TQC2060_R01PastFilter: defaultTQC2060_R01Filter,
		selectedTQC2060_R01: undefined,
		editTQC2060_R01: defaultTQC2060_R01HdrDto,
		TQC2060_R01List: [],
		TQC2060_R01DetailList: [],
		deletedTQC2060_R01DetailList: [],
		selectedTQC2060_R01DetailList: [],
		originalTQC2060_R01DetailList: [],
		allCount: 0,
		prevSampleCount: undefined,
		isEditing: false,
		prevTestDetails: undefined,
		detailFetchTrigger: false,
		scrollTop: null,
		detailScrollTop: null,
	})),

	
}));
